import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LOW_ATTENDANCE_PERCENT } from '../../../../models/attendance.school.model';

@Component({
  selector: 'app-progress-determinate',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-determinate.component.html',
  styleUrl: './progress-determinate.component.css',
})
export class ProgressDeterminateComponent {
  @Input() progress: number = 0;
  @Input() loading$: Observable<boolean> = new Observable();
  readonly lowPercent = LOW_ATTENDANCE_PERCENT;

  constructor() {}
}
